import { useEffect } from "react";

const DEFAULT_TITLE = "Ma.Vi Gioielli — Gioielli Artigianali Personalizzati";
const DEFAULT_DESCRIPTION =
  "Gioielli artigianali in argento personalizzabili: collane, bracciali e pendenti incisi a mano con i nomi dei tuoi bambini, creati nel nostro atelier.";
const DEFAULT_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1";

export default function Seo({ title, description, noindex }) {
  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (title) document.title = title;
    if (description && metaDescription) metaDescription.setAttribute("content", description);
    if (noindex && metaRobots) metaRobots.setAttribute("content", "noindex, nofollow");
    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDescription) metaDescription.setAttribute("content", DEFAULT_DESCRIPTION);
      if (metaRobots) metaRobots.setAttribute("content", DEFAULT_ROBOTS);
    };
  }, [title, description, noindex]);
  return null;
}
